import type { LanguageCode as ShopifyLanguageCode } from '@ifixit/shopify-storefront-client';
import languagesConfig from './languages-config.json';

export type LanguageCode = keyof typeof languagesConfig;

export interface Language {
   code: LanguageCode;
   name: string;
   localName: string;
   shopifyLanguage: ShopifyLanguageCode;
}

const allLanguageCodes = new Set<string>(Object.keys(languagesConfig));

export function isLanguageCode(code: string): code is LanguageCode {
   return allLanguageCodes.has(code);
}

export function languageFromCode(code: LanguageCode): Language {
   const language = languagesConfig[code];
   return {
      code,
      name: language.name,
      localName: language.localName,
      shopifyLanguage: language.shopifyLanguage as ShopifyLanguageCode,
   };
}
